// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-2aLJl","title":"title-1swDO","description":"description-4ZpMp","header":"header-25fnt","selected":"selected-2eSCx"};